<template>
  <div class="ui-block" :data-cy="groupCard">
    <!-- Post -->
    <article class="hentry post video" data-cy="groupCard">
      <div class="row author vcard inline-flex-items content-order">
        <div
          class="col order-xl-1 order-lg-1"
        >
          <router-link :to="`/s-app/group-page/${group.groupId}`">
            <img
              :src="getGroupImagePath(group.group)"
              alt="author"
              class="group-image fit-contain"
            />
            <md-avatar class="md-avatar-icon" :class="[getGroupIconClass]">
              <md-icon>groups </md-icon>
            </md-avatar>
          </router-link>
          <div class="col group-card">
              <router-link :to="`/s-app/group-page/${group.groupId}`">
                <p class="group-name-text text fn">
                  {{ getGroupName(group.group) }}
                </p>
                <md-tooltip v-if="nameTooBig"
                md-direction="bottom"
                class="s-tooltip tp-trade-position"
              >
                {{ getGroupName(group.group) }}
              </md-tooltip>
              </router-link>
            <div class="col">
              <p class="privacy-text text privacy">{{ showPrivacy(group.group.privacy) }}</p>
            </div>
          </div>
        </div>
        <div class="top-right-content">
          <span class="zip-text"> {{ group.group.city }} </span>
          <p class="members-text text members">{{ group.membersCount }} members</p>
        </div>
      </div>

      <div>
        <span class="description-text">
          {{ group.group.description }}
        </span>
      </div>
    </article>
    <!-- .. end Post -->
  </div>
</template>

<script>
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import groupPrivacy from "@/enum/group-privacy";
import UserHelper from '../../mixins/UserHelper.vue';

export default {
  name: "CardGroup",
  props: ["group"],
  mixins: [GroupHelperVue, UserHelper],
  data() {
    return {
      moderatedIds: [],
      members: [],
      gPrivacy: groupPrivacy,
    };
  },
  methods: {
    storeModeratedIds() {
      this.myModeratedGroups.forEach((element) => {
        this.moderatedIds.push(element.groupId);
      });
    },
    showPrivacy(privacy) {
      switch (privacy) {
        case 1:
          return "Public";
        case 2:
          return "Private";
        case 3:
          return "Hidden";
        default:
          return "";
      }
    },
  },
  computed: {
    groupCard() {
      return `cardGroup_${this.getGroupName(this.group.group)}`;
    },
    getGroupIconClass() {
      if (this.gPrivacy.PUBLIC === this.group.group.privacy) {
        return "md-primary";
      } else if (this.gPrivacy.PRIVATE === this.group.group.privacy) {
        return "md-danger";
      }
      return "";
    },
    nameTooBig() {
      if (this.group.group.name.length > 10) return true;
      return false;
    },
  },
  created() {
    this.storeModeratedIds();
  },
  async mounted() {
    $(".author-date").tooltip();
  },
};
</script>

<style lang="scss" scoped>


.group-image {
  height: 64px;
  width: 64px;
  min-width: 64px;
}
.group-card{
  display: block;
  }
.description-text {
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.group-name-text {
  font-weight: 700;
  margin-top: 12px;
  margin-bottom: 10px;
}
.text {
  font-style: normal;
  font-size: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 1.5px;
  color: $black !important;
}
.post {
  padding: 8px 24px;
}
.author-date {
  overflow: hidden;
  text-overflow: ellipsis;
}
.privacy{
  float: left;
}
.privacy-text {
  font-weight: 400;
  letter-spacing: 1.25px;
  opacity: 0.7;
  margin: 0px;
}
.members-text {
  font-weight: 400;
  letter-spacing: 1.25px;
  opacity: 0.7;
  margin: 10px 0 0 0 !important;
}
.zip-text {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
.top-right-content {
  display: flex;
  flex-direction: column;
}
.members {
  float: right;
}
.s-tooltip {
  margin-top: -6px;
  background: rgba(147, 147, 147, 0.4);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border-radius: 4px;
  color: $black;
  font-weight: 500;
}
@media screen and (max-width: 600px) {
  .text {
    font-size: 14px;
  }
}

.inline-flex-items .col a > .md-theme-swampum-primary {
  transform: translatex(-31px) translatey(20px);
  position: absolute;
  min-width: 0px;
  width: 32px;
  height: 32px;
  top: 16px;
}
.md-danger {
  background-color: $danger !important;
}
@media screen and (min-width: 1024px) {
  .content-order {
    flex-direction: row-reverse;
  }
}
</style>
